export const formatDate = (dateString) => {
    if (!dateString) return 'No deadline available';
  
    // Parse the date string into a Date object
    const date = new Date(dateString);
  
    // Define an array of month names
    const months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
  
    // Extract day, month, and year
    const day = date.getDate().toString().padStart(2, '0'); // Ensures two-digit day (e.g., '01')
    const month = months[date.getMonth()]; // Map month number to name
    const year = date.getFullYear();
  
    // Return formatted string
    return `${day}${month}${year}`;
  };
  
  export const unformatDate = (formatted) => {
    const months = {
      JAN: '01', FEB: '02', MAR: '03', APR: '04', MAY: '05', JUN: '06',
      JUL: '07', AUG: '08', SEP: '09', OCT: '10', NOV: '11', DEC: '12'
    };
  
    const day = formatted.substring(0, 2);
    const mon = months[formatted.substring(2, 5).toUpperCase()];
    const year = formatted.substring(5);
  
    return `${year}-${mon}-${day}`;
  };

  